import { useState, useEffect, cloneElement, type FocusEvent } from 'react';

import type { TItemSelector } from 'libs/design-system/src/types/item_selector/item_selector';
import type {
  ICheckboxVariant,
  IRadioVariant,
} from 'libs/design-system/src/types/checkbox';

import { Checkbox } from '../../Checkbox';

import styles from './item-selector.module.scss';
export const ItemSelector = ({
  id,
  size = 'sm',
  type = 'checkbox',
  text,
  hintText,
  disabled = false,
  badgeProps,
  onChangeHandler,
  onClickHandler,
  render,
  ...rest
}: TItemSelector) => {
  const { checked, checkboxIcon } = rest as ICheckboxVariant;
  const { selected } = rest as IRadioVariant;
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isChecked, setIsChecked] = useState(checked);
  const [isSelected, setIsSelected] = useState(selected);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  useEffect(() => {
    setIsSelected(selected);
  }, [selected]);

  const onMouseOverHandler = () => setIsHovered(true);
  const onMouseOutHandler = () => setIsHovered(false);
  const onFocusHandler = (e: FocusEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsFocused(true);
  };
  const onBlurHandler = (e: FocusEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsFocused(false);
  };
  const handleClick = (e: any) => {
    e.preventDefault();

    if (disabled) return;

    if (type === 'radio') {
      if (!isSelected) {
        setIsSelected(true);
        onClickHandler?.(true, text || hintText as string);
      };
    } else {
      setIsChecked((prevState) => {
        const newState = !prevState;
        onClickHandler?.(newState, text || hintText as string);
        return newState;
      });
    }
  };

  return (
    <div
      className={styles['item-selector']}
      data-item-selector-disabled={disabled}
      data-item-selector-size={size}
      data-item-selector-checked={isChecked}
      data-item-selector-selected={selected || isSelected}
      data-item-selector-hovered={isHovered}
      data-item-selector-focused={isFocused}
      tabIndex={0}
      onClick={handleClick}
      onMouseOver={onMouseOverHandler}
      onMouseOut={onMouseOutHandler}
      onFocusCapture={onFocusHandler}
      onBlurCapture={onBlurHandler}
    >
      {cloneElement(
        <Checkbox
          id={id}
          size={size}
          checkboxIcon={checkboxIcon}
          type={type}
          selected={isSelected}
          text={text}
          hintText={hintText}
          disabled={disabled}
          checked={isChecked}
          badgeProps={badgeProps}
          onChangeHandler={onChangeHandler}
          render={render}
          // onClickHandler={onClickHandler}
        />,
        { hovered: isHovered, focused: isFocused }
      )}
    </div>
  );
};

export default ItemSelector;